'use strict';

var React = require('react');

var SvgCreditCardReaderIcon = function SvgCreditCardReaderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.75 3.5a2.25 2.25 0 0 0-2.25 2.25v4.75a2.25 2.25 0 0 0 2.25 2.25h.32c-.046.243-.07.494-.07.75v.75a1 1 0 0 0 1 1h2.25v.75a.75.75 0 0 0 1.5 0v-.75h2.25a1 1 0 0 0 1-1v-.75a4.02 4.02 0 0 0-.07-.75h.32a2.25 2.25 0 0 0 2.25-2.25v-4.75a2.25 2.25 0 0 0-2.25-2.25h-8.5Zm6.75 10.25v-.25a2.5 2.5 0 0 0-5 0v.25h5Zm-2.5-4.25a3.996 3.996 0 0 0-3.308 1.75h-.942a.75.75 0 0 1-.75-.75v-2.25h10v2.25a.75.75 0 0 1-.75.75h-.942a3.996 3.996 0 0 0-3.308-1.75Zm5-3.25v-.5a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0-.75.75v.5h10Z"
  }));
};
SvgCreditCardReaderIcon.displayName = "CreditCardReaderIcon";

exports.SvgCreditCardReaderIcon = SvgCreditCardReaderIcon;
